

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { EmbeddedContent } from 'client-website-ts-library/types/EmbeddedContent/EmbeddedContent';

@Component
export default class Embeddable extends Vue {
  @Prop({ required: true })
  private readonly embeddable!: EmbeddedContent;

  @Prop({ default: false })
  private readonly autoPlay!: boolean;

  @Prop({ default: '0.625' })
  private readonly ratio!: string;

  private readonly origin: string = window.location.origin;

  private time = null;

  mounted() {
    setTimeout(() => {
      console.log(this.embeddable);
    }, 10000);
  }
}
